/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.51   Rana simulation core release: 3.7.3   deployed on:  10:12AM (UTC) on September 07, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from "../runtime";
/**
 * Serializer class for the personal API keys
 * @export
 * @interface PersonalAPIKey
 */
export interface PersonalAPIKey {
  /**
   *
   */
  readonly prefix?: string;
  /**
   * A space-separated list of scopes (options: basic simulate create lizardrain lizardprocess manageusers managecontracts test livesite waterquality). Alternatively, use '*:readwrite' for all scopes.
   */
  scope: string;
  /**
   * A free-form name for the API key. Need not be unique. 50 characters max.
   */
  name: string;
  /**
   * Once API key expires, clients cannot use it anymore.
   */
  expiryDate?: Date | null;
  /**
   *
   */
  readonly created?: Date;
  /**
   * If the API key is revoked, clients cannot use it anymore. (This cannot be undone.)
   */
  revoked?: boolean;
  /**
   * Last time the API key was used.
   */
  readonly lastUsed?: Date | null;
}

/**
 * Check if a given object implements the PersonalAPIKey interface.
 */
export function instanceOfPersonalAPIKey(value: object): value is PersonalAPIKey {
  if (!("scope" in value) || value["scope"] === undefined) return false;
  if (!("name" in value) || value["name"] === undefined) return false;
  return true;
}

export function PersonalAPIKeyFromJSON(json: any): PersonalAPIKey {
  return PersonalAPIKeyFromJSONTyped(json, false);
}

export function PersonalAPIKeyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PersonalAPIKey {
  if (json == null) {
    return json;
  }
  return {
    prefix: json["prefix"] == null ? undefined : json["prefix"],
    scope: json["scope"],
    name: json["name"],
    expiryDate:
      json["expiry_date"] === undefined
        ? undefined
        : json["expiry_date"] === null
        ? null
        : parseDateTime(json["expiry_date"]),
    created: json["created"] == null ? undefined : parseDateTime(json["created"]),
    revoked: json["revoked"] == null ? undefined : json["revoked"],
    lastUsed:
      json["last_used"] === undefined
        ? undefined
        : json["last_used"] === null
        ? null
        : parseDate(json["last_used"]),
  };
}

export function PersonalAPIKeyToJSON(json: any): PersonalAPIKey {
  return PersonalAPIKeyToJSONTyped(json, false);
}

export function PersonalAPIKeyToJSONTyped(
  value?: Omit<PersonalAPIKey, "prefix" | "created" | "lastUsed"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    scope: value["scope"],
    name: value["name"],
    expiry_date:
      value["expiryDate"] == null ? value["expiryDate"] : serializeDateTime(value["expiryDate"]),
    revoked: value["revoked"],
  };
}
